import { createAsyncTypes } from 'utils/ActionCreator'

import { colors } from 'components/styles/styledTheme'

export const INCIDENT_REQUEST_ASYNC = createAsyncTypes(
  'INCIDENT_REQUEST',
  'ResolutionCenter/AtoIncident'
)

export const PAGINATE_CHANGE = 'ResolutionCenter/AtoIncident/PAGINATE_CHANGE'
export const FILTER_CHANGE = 'ResolutionCenter/AtoIncident/FILTER_CHANGE'

export const ATO_STATES = {
  COMPROMISED: 3,
  SAFE: 2,
}

export const CLASSIFICATION_STATES = [
  {
    state: ATO_STATES.COMPROMISED,
    text: 'Compromised',
    action: 'Remediate Account',
    iconName: 'phishing',
    iconColor: colors.negative,
  },
  {
    state: ATO_STATES.SAFE,
    text: 'Safe',
    action: 'Ignore',
    iconName: 'check-circle',
    iconColor: colors.positive,
  },
]

export const ALERTS_ICONS = {
  1: 'rule-alert',
  2: 'login-alert',
  3: 'other-alert',
}
